import { z } from "zod";

import { ResourceMaturity } from "@examspark/types";

import { ApiV1FilterTagsSchema, ApiV1TagSchema } from "./shared";

export const ApiV1ListExamsRequestSchema = z.object({
  filter: z
    .object({
      tags: ApiV1FilterTagsSchema.optional(),
    })
    .optional(),
});

export const ApiV1CreateExamRequestSchema = z.object({
  name: z.string().optional(),
  title: z.string().optional(),
  maturity: z
    .enum([
      ResourceMaturity.Draft,
      ResourceMaturity.InDevelopment,
      ResourceMaturity.Operational,
    ])
    .optional(),
  tags: z.array(ApiV1TagSchema).optional(),
  content: z
    .object({
      sections: z.array(
        z.object({
          items: z.array(
            z.object({
              itemId: z.string(),
            }),
          ),
        }),
      ),
    })
    .optional(),
});

export const ApiV1PutExamRequestSchema = ApiV1CreateExamRequestSchema;
export const ApiV1DuplicateExamRequestSchema = ApiV1CreateExamRequestSchema;
